import { render, staticRenderFns } from "./Garantias.vue?vue&type=template&id=5e023aae&scoped=true&"
import script from "./Garantias.vue?vue&type=script&lang=js&"
export * from "./Garantias.vue?vue&type=script&lang=js&"
import style0 from "./Garantias.vue?vue&type=style&index=0&id=5e023aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e023aae",
  null
  
)

export default component.exports